export default __webpack_public_path__ + "static/media/vistior.0f9ac403.png";